import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineAsyncComponent, ref, shallowRef } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const Questionnairee = defineAsyncComponent(() => import('./Questionnairee.vue'));
const Establish = defineAsyncComponent(() => import('./Establish.vue'));

const tabs = shallowRef([
  {
    key: 0,
    title: '问卷调查',
    component: Questionnairee,
  },
  {
    key: 1,
    title: '创建问卷',
    component: Establish,
  },
]);
const isComponent = ref(0);
const getComponent = (res: any) => {
  isComponent.value = res;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(tabs)[isComponent.value].component), {
    onGetComponent: _cache[0] || (_cache[0] = ($event: any) => (getComponent($event)))
  }, null, 32))
}
}

})